import { eCommerceMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { eCommerceBreadcrumb } from "../../data/DataBreadcrumb";
import { defBreadcrumb } from "../../data/DataBreadcrumb";
import {
  ECommerceAccordion,
  ECommerceHeading,
  ECommerceWrapper,
} from "src/views/cara-pembayaran/e-commerce";

const ECommerce = (props) => {
  const { breadcrumb, eCommerceBreadcrumb, title, description, path } = props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={eCommerceBreadcrumb} />

      <ECommerceWrapper>
        <ECommerceHeading />
        <ECommerceAccordion />
      </ECommerceWrapper>
    </Layout>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = eCommerceMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title,
      },
    },
  ];

  return {
    props: {
      breadcrumb,
      eCommerceBreadcrumb,
      title,
      description,
      path,
    },
  };
};

export default ECommerce;
